import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { ClientsService } from 'src/app/business-service/clients/clients.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ORGANIZATION_TYPES } from '../../shared/constants/api-constants';

@Component({
  selector: 'app-client-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.scss'],
})
export class ClientFormComponent  implements OnInit {

  clientForm!: FormGroup;

  editClientId:any;
  clientDetails:any;
  constructor(
    private _modalController: ModalController,
    private _fb: FormBuilder,
    private _validationService: InputValidationsService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _clientService: ClientsService,
    private _reloadService: ComponentReloadService
  ) { }

  ngOnInit() {
    if(this.editClientId){
      this._clientService.getClient(this.editClientId).subscribe((data)=>{
        this.clientDetails = data;
        this.patchLeadFormData(this.clientDetails);
      })
    }
    

    this.clientForm = this._fb.group({
      clientId: [''],
      firstName: [''],
      firstNameWithSalutation: [null, [Validators.required]],
      lastName: ['', [this._validationService.noSpacesValidator()]],
      phoneNumber: [{countryCode: '+91', number: '' }, [Validators.required ]],
      emailId: ['', [Validators.email]],
      status: ['']
    });


  }

  async closeModal(submitted: boolean = false) {
    this._modalController.dismiss();
  }

  patchLeadFormData(formData: any) {    
    this.clientForm.patchValue({
      clientId: formData.clientId,
      firstNameWithSalutation: {firstName: formData.firstName, salutation: formData.salutation},
      lastName: formData.lastName,
      phoneNumber: {
        countryCode: formData.phoneNumber.countryCode,
        phone: formData.phoneNumber.phone
      },
      emailId: formData.email,
      status: formData.status
    });    
  }

  onSubmit(){
    if(this.clientForm.valid){
      if(this.editClientId){
        this.serializeEditFormData(this.clientForm.getRawValue()).then(formData => {
          this._clientService.updateClient(this.editClientId,formData).subscribe((data)=>{
            if(data){
              this._responseNotificationService.showMessage("Client Updated Successfully!")
           
              this.closeModal(true);
              this._reloadService.triggerClientsReload();
            }
          })
        })
      }
    }else{
      this.clientForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
     
      this._globalService.customAlert("Form is invalid, please fill all required fields.");
      // this._responseNotificationService.showMessage("Form is invalid, please fill all required fields.", true);   
    }
  }


  private async serializeEditFormData(formData: any) {
    const serializedData = {
      clientId: formData.clientId,
      firstName: formData.firstNameWithSalutation.firstName,
      salutation: formData.firstNameWithSalutation.salutation,
      lastName: formData.lastName,
      phoneNumber: {
        countryCode: formData.phoneNumber.countryCode,
        phone: formData.phoneNumber.phone
      },
      email: formData.emailId,
      status: formData.status,
      type: ORGANIZATION_TYPES.AGENT,
      id: this.clientDetails.id,
      category: this.clientDetails.category,
      createDate: this.clientDetails.createDate,
      createdBy: this.clientDetails.createdBy,
      isDeleted: this.clientDetails.isDeleted,
      modifiedBy: this.clientDetails.modifiedBy,
      modifiedDate: this.clientDetails.modifiedDate,
      organizationId: this.clientDetails.organizationId
    };
    return serializedData;
  }  

}
